module.exports = __webpack_public_path__ + "img/Calque.24a552e6.png";